import 'lib/semantic-ui/dist/semantic.js';
import 'lib/semantic-ui/dist/semantic.css';
import 'lib/anyfont/index.scss';
import 'views/support/_animations.scss';
import './index.scss';

import _ from 'underscore';
import _ext from 'lib/underscore_extensions';
import _str from 'underscore.string/index.js';

import 'lib/mobile_detect_wrapper';
import 'stores/shared';
import 'stores/plugins';
import 'action_creators'; // Rebuilding :(

import 'imagefill';
import 'jquery-deparam';
import 'jquery-postmessage';
import 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/lib/libphonenumber/build/utils.js';
import 'jquery.dotdotdot';

import stateTreeInitializer from 'initializers/state_tree';

import 'initializers/flux_stores';
import 'initializers/iframe_postmessage';
import 'initializers/iframe_integration';
import 'initializers/global_ajax_hooks';
import 'initializers/viewport_watcher';
import { initSentry } from '@anyroad/sentry';
import { wrapAllComponents } from 'lib/withIntl';

_.mixin(_ext);
_.str = _str;

const React = require('react');

window.React = React;
window.ReactDOM = require('react-dom');

initSentry({ application: 'plugins' }, null, {
  tracesSampleRate: 0.1,
  replayOnErrorSampleRate: 0.1,
});

const Plugins = require('views/plugins').default;
const TourHeader = require('views/anyguide/website/tour_header').default;
const Map = require('views/shared/tours/page/map').default;

window.Views = wrapAllComponents({
  Plugins,
  Anyguide: {
    Website: {
      TourHeader,
    },
  },
  Shared: {
    Tours: {
      Page: {
        Map,
      },
    },
  },
});

function _x() {}

stateTreeInitializer.call();
